<ng-container *ngIf="variant === 'menu'; else buttonsTpl">
  <div class="menu-wrapper" *ngIf="visibleActions.length > 0">
    <!-- Chat stays outside the menu -->
    <button
      *ngIf="showChat"
      mat-icon-button
      class="chat-btn"
      [matTooltip]="'applications.menu.message' | translate"
      (click)="handle('message')"
      aria-label="Open chat">
      <mat-icon>chat</mat-icon>
    </button>

    <!-- Three-dots menu for all other actions -->
    <button *ngIf="menuActions.length > 0" mat-icon-button [matMenuTriggerFor]="actionsMenu" aria-label="More actions">
      <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #actionsMenu="matMenu">
      <button mat-menu-item *ngFor="let a of menuActions" (click)="handle(a.key)">
        <mat-icon *ngIf="a.icon">{{ a.icon }}</mat-icon>
        <span>{{ a.label | translate }}</span>
      </button>
    </mat-menu>
  </div>
</ng-container>

<ng-template #buttonsTpl>
  <div class="actions-row" [class.mobile]="isMobile">
    <app-button
      *ngFor="let a of visibleActions"
      (click)="handle(a.key)"
      [type]="a.appearance"
      [leftIcon]="a.asset"
      [state]="ButtonState.REGULAR"
      [size]="ButtonSize.LARGE"
      [label]="a.label | translate"
      [showLeftIcon]="a.appearance === 'secondary'"
    ></app-button>
  </div>
</ng-template>
